import {
  Box,
  Tab,
  Tabs,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AddSkillBookTemplate from "../../routes/Profile/AddSkillBook/AddSkillBookTemplate";
import AddSkillBookExternalTrainingTemplate from "../../routes/Profile/ExternalTrainingAddSkillbook/AddSkillBookExternalTrainingTemplate";
import { AddSkillBookTemplateProps } from "routes/Profile/ExternalTrainingAddSkillbook/AddSkillBook.types";

export const ExternalTrainingModal: React.FC<AddSkillBookTemplateProps> = ({
  closeModal,
  initialData
}) => {
  const initialTab = initialData?.type?.toLowerCase() === "consuntivazione" ? 1 : 0;
  const [tabIndex, setTabIndex] = useState(initialTab);
  const theme = useTheme();
  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);

  const handleChange = (_: unknown, newValue: number) => {
    setTabIndex(newValue);
  };

  // Al cambio tab riporta il contenuto in cima con scroll animato
  useEffect(() => {
    contentRef.current?.scrollTo({ behavior: "smooth", top: 0 });
  }, [tabIndex]);

  return (
    <>
      { /* Contenitore delle Tabs */ }
      <Box
        sx={ {
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          maxHeight: "495px",
          overflowY: "auto",
          width: "100%",
          color: theme.customColors.exploreCardText,
          borderBottom: theme.customColors.border,
          pb: 1
        } }
      >
        <Tabs
          value={ tabIndex }
          onChange={ handleChange }
          variant="fullWidth"
          centered
          TabIndicatorProps={ {
            style: {
              backgroundColor: theme.customColors.systemSecondary01,
              height: 3
            }
          } }
          sx={ {
            width: "100%",
            borderBottom: "1px solid #333"
          } }
        >
          <Tab
            label={ t("external_training") }
            sx={ {
              width: "100%",
              flex: 1,
              textAlign: "center",
              color:
                tabIndex === 0
                  ? `${theme.customColors.systemSecondary01} !important`
                  : `${theme.customColors.exploreCardText} !important`,
              fontSize: "1rem",
              textTransform: "none"
            } }
          />
          <Tab
            label={ t("Consuntivation") }
            sx={ {
              width: "100%",
              flex: 1,
              textAlign: "center",
              color:
                tabIndex === 1
                  ? `${theme.customColors.systemSecondary01} !important`
                  : `${theme.customColors.exploreCardText} !important`,
              fontSize: "1rem",
              textTransform: "none"
            } }
          />
        </Tabs>
      </Box>

      { /* Contenitore dei contenuti dei Tab */ }
      <Box
        ref={ contentRef }
        sx={ {
          flexDirection: "column",
          justifyContent: "center",
          maxHeight: "calc(90vh - 160px)",
          overflowY: "auto",
          color: theme.customColors.exploreCardText,
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          "& .MuiTypography-root, .MuiInputLabel-root,.MuiInputBase-input, span, svg, path":{
            // color: `${theme.customColors.exploreCardText} !important`,
            // fill: `${theme.customColors.exploreCardText} !important`
          }
        } }
      >
        { tabIndex === 0 && (
          <Box>
            <Typography
              fontSize={ "1rem" }
              fontWeight={ "400" }
              color={ theme.customColors.exploreCardText }
              sx={ { 
                marginRight: "auto",
                mb: 2,
                opacity: 0.75
              } }
            >
              { t("request_training_field") }
            </Typography>
            <AddSkillBookExternalTrainingTemplate closeModal={ closeModal } initialData={ initialData } />
          </Box>
        ) }
        { tabIndex === 1 && (
          <Box>
            { /* <Typography
              variant="h6"
              color={ theme.customColors.exploreCardText }
              sx={ { marginRight: "auto", mb: 2 } }
            > */ }
            { /* Titolo facoltativo per la sezione Consuntivazioni */ }
            { /* </Typography> */ }
            <AddSkillBookTemplate closeModal={ closeModal } initialData={ initialData } />
          </Box>
        ) }
      </Box>
    </>
  );
};

export default ExternalTrainingModal;
